import React, { useState, useEffect } from "react";
import "./Payment.scss";
import HeaderOne from "../../HeaderOne";
import Breadcrumb from "../../Breadcrumb";
import FooterOne from "../../FooterOne";
import Swal from "sweetalert2";

const Payment = () => {
  const [order, setOrder] = useState(null);

  // ======= Swal Toast =========
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    timer: 2000,
    showConfirmButton: false,
  });

  // ================== MOCK DATA ==================
  const mockOrder = {
    id: "ORDER123456",
    billing: {
      firstName: "Kumar",
      lastName: "Avadhia",
      phone: "9876543210",
      address1: "A2- Building Name",
      address2: "Sector 21, Mumbai",
      city: "Mumbai",
      pincode: "400001",
      state: "Maharashtra",
    },
    items: [
      { id: 1, name: "Smart Watch", qty: 1, price: 1499 },
      { id: 2, name: "Wireless Earbuds", qty: 2, price: 999 },
    ],
    subtotal: 1499 + 2 * 999,
    tax: 50,
    delivery: 0,
    totalAmount: 1499 + 2 * 999 + 50,
  };

  useEffect(() => {
    // Simulate network delay
    setTimeout(() => {
      setOrder(mockOrder);
    }, 500);
  }, []);

  // ================== MOCK COD ==================
  const handleCOD = () => {
    Swal.fire({
      icon: "success",
      title: "COD Order Placed!",
      text: "Your order has been placed successfully.",
      confirmButtonColor: "#3085d6",
    }).then(() => {
      window.location.href = "/user/orders";
    });
  };

  // ================== MOCK ONLINE PAYMENT ==================
  const handleOnlinePayment = () => {
    Toast.fire({
      icon: "info",
      title: "Redirecting to mock payment...",
    });

    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "Payment Successful!",
        text: "Online payment completed successfully.",
      }).then(() => {
        window.location.href = "/user/orders";
      });
    }, 800);
  };

  if (!order) return <div className="loader">Loading Payment Details...</div>;

  return (
    <>
    <HeaderOne/>
    <Breadcrumb/>
      <div className="payment-container">

      <h2 className="payment-title">Complete Your Payment</h2>

      <div className="payment-layout">

        {/* LEFT - Billing + Items */}
        <div className="payment-left">

          {/* Billing */}
          <div className="payment-card">
            <h3>Billing Address</h3>
            <p><strong>Name:</strong> {order.billing.firstName} {order.billing.lastName}</p>
            <p><strong>Phone:</strong> {order.billing.phone}</p>
            <p>
              <strong>Address:</strong> {order.billing.address1}, {order.billing.address2},{" "}
              {order.billing.city} - {order.billing.pincode}, {order.billing.state}
            </p>
          </div>

          {/* Items */}
          <div className="payment-card">
            <h3>Your Items</h3>
            {order.items.map((item) => (
              <div key={item.id} className="payment-item">
                <span>{item.name}</span>
                <span>Qty: {item.qty}</span>
                <span>₹ {item.qty * item.price}</span>
              </div>
            ))}
          </div>

        </div>

        {/* RIGHT - Summary + Payment */}
        <div className="payment-right">

          <div className="payment-summary">
            <h3>Order Summary</h3>

            <div className="summary-row">
              <span>Subtotal</span>
              <span>₹ {order.subtotal}</span>
            </div>

            <div className="summary-row">
              <span>Tax</span>
              <span>₹ {order.tax}</span>
            </div>

            <div className="summary-row">
              <span>Delivery Charges</span>
              <span>₹ {order.delivery}</span>
            </div>

            <div className="summary-total">
              <span>Total</span>
              <span>₹ {order.totalAmount}</span>
            </div>
          </div>

          <button className="btn-cod" onClick={handleCOD}>
            Cash On Delivery (COD)
          </button>

          <button className="btn-online" onClick={handleOnlinePayment}>
            Pay Online (Mock Payment)
          </button>

        </div>
      </div>
      </div>
    <FooterOne/>
    </>
  );
};

export default Payment;
